import React, { useMemo } from 'react';
import './StockVisualizationTableInfo.css';

const formatISODate = (dateStr) => {
  if (typeof dateStr === 'string' && /^\d{4}-\d{2}-\d{2}/.test(dateStr)) {
    return dateStr.slice(0, 10);
  }
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return String(dateStr);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};

const formatNumber = (value, digits = 2) => {
  if (value === null || value === undefined || Number.isNaN(value)) return '—';
  return Number(value).toLocaleString('en-US', {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits
  });
};

const formatInteger = (value) => {
  if (value === null || value === undefined || Number.isNaN(value)) return '—';
  return Number(value).toLocaleString('en-US');
};

const StockVisualizationTableInfo = ({ chartData, stockInfo }) => {
  const latest = useMemo(() => {
    if (!chartData || chartData.length === 0) return null;
    return chartData.reduce((acc, item) => {
      const accTime = acc ? new Date(acc.date).getTime() : -Infinity;
      const itemTime = new Date(item.date).getTime();
      return itemTime > accTime ? item : acc;
    }, null);
  }, [chartData]);

  if (!latest) {
    return (
      <div className="stock-visualization-table">
        <div className="sv-table-header">
          <div className="sv-title">Key Metrics</div>
          <div className="sv-subtitle">Latest data point</div>
        </div>
        <div className="sv-table-loading">Loading chart data...</div>
      </div>
    );
  }

  const change = latest.close - latest.open;
  const changePercent = latest.changePercent;
  const isChangePositive = change > 0;
  const isChangePercentPositive = changePercent > 0;
  const isCloseUp = latest.close > latest.open;

  return (
    <div className="stock-visualization-table">
      <div className="sv-table-header">
        <div className="sv-title">Key Metrics</div>
        <div className="sv-subtitle">Latest data point</div>
      </div>
      <div className="sv-metrics-table-wrap">
        <table className="sv-metrics-table">
          <thead>
            <tr>
              <th>Symbol</th>
              <th>Date</th>
              <th>Open</th>
              <th>High</th>
              <th>Low</th>
              <th>Close</th>
              <th>Volume</th>
              <th>Change</th>
              <th>Change %</th>
              <th>VWAP</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{stockInfo?.ticker || '—'}</td>
              <td>{formatISODate(latest.date)}</td>
              <td>${formatNumber(latest.open)}</td>
              <td className="sv-positive">${formatNumber(latest.high)}</td>
              <td className="sv-negative">${formatNumber(latest.low)}</td>
              <td className={isCloseUp ? 'sv-positive' : 'sv-negative'}>${formatNumber(latest.close)}</td>
              <td>{formatInteger(latest.volume)}</td>
              <td className={isChangePositive ? 'sv-positive' : 'sv-negative'}>${formatNumber(change)}</td>
              <td className={isChangePercentPositive ? 'sv-positive' : 'sv-negative'}>{formatNumber(changePercent)}%</td>
              <td>${formatNumber(latest.vwap)}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default StockVisualizationTableInfo;
